export default __webpack_public_path__ + "static/media/placeholder-4.da156cd4.jpg";